// Geographic data for International Platform
export const COUNTRIES = [
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'IT', name: 'Italie', flag: '🇮🇹' },
  { code: 'GB', name: 'Royaume-Uni', flag: '🇬🇧' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦' },
  { code: 'RO', name: 'Roumanie', flag: '🇷🇴' },
  { code: 'RU', name: 'Russie', flag: '🇷🇺' },
  { code: 'BE', name: 'Belgique', flag: '🇧🇪' },
  { code: 'CH', name: 'Suisse', flag: '🇨🇭' },
  { code: 'DE', name: 'Allemagne', flag: '🇩🇪' },
  { code: 'ES', name: 'Espagne', flag: '🇪🇸' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'US', name: 'États-Unis', flag: '🇺🇸' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨' },
  { code: 'MA', name: 'Maroc', flag: '🇲🇦' },
  { code: 'TN', name: 'Tunisie', flag: '🇹🇳' },
  { code: 'SN', name: 'Sénégal', flag: '🇸🇳' },
  { code: 'CI', name: 'Côte d\'Ivoire', flag: '🇨🇮' },
  { code: 'IE', name: 'Irlande', flag: '🇮🇪' },
  { code: 'PL', name: 'Pologne', flag: '🇵🇱' },
  { code: 'MD', name: 'Moldavie', flag: '🇲🇩' },
  { code: 'BY', name: 'Biélorussie', flag: '🇧🇾' },
  { code: 'CZ', name: 'Tchéquie', flag: '🇨🇿' },
  { code: 'AT', name: 'Autriche', flag: '🇦🇹' },
  { code: 'HU', name: 'Hongrie', flag: '🇭🇺' },
  { code: 'NL', name: 'Pays-Bas', flag: '🇳🇱' },
  { code: 'GR', name: 'Grèce', flag: '🇬🇷' },
  { code: 'BG', name: 'Bulgarie', flag: '🇧🇬' },
  { code: 'EE', name: 'Estonie', flag: '🇪🇪' },
  { code: 'LV', name: 'Lettonie', flag: '🇱🇻' },
  { code: 'LT', name: 'Lituanie', flag: '🇱🇹' },
  { code: 'SK', name: 'Slovaquie', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovénie', flag: '🇸🇮' },
  { code: 'HR', name: 'Croatie', flag: '🇭🇷' },
  { code: 'RS', name: 'Serbie', flag: '🇷🇸' },
  { code: 'GE', name: 'Géorgie', flag: '🇬🇪' },
  { code: 'IL', name: 'Israël', flag: '🇮🇱' },
  { code: 'OTHER', name: 'Autre pays', flag: '🌍' },
];

// France Regions
export const FRANCE_REGIONS = [
  { code: 'ARA', name: 'Auvergne-Rhône-Alpes' },
  { code: 'BFC', name: 'Bourgogne-Franche-Comté' },
  { code: 'BRE', name: 'Bretagne' },
  { code: 'CVL', name: 'Centre-Val de Loire' },
  { code: 'COR', name: 'Corse' },
  { code: 'GES', name: 'Grand Est' },
  { code: 'HDF', name: 'Hauts-de-France' },
  { code: 'IDF', name: 'Île-de-France' },
  { code: 'NOR', name: 'Normandie' },
  { code: 'NAQ', name: 'Nouvelle-Aquitaine' },
  { code: 'OCC', name: 'Occitanie' },
  { code: 'PDL', name: 'Pays de la Loire' },
  { code: 'PAC', name: 'Provence-Alpes-Côte d\'Azur' },
  { code: 'GUA', name: 'Guadeloupe' },
  { code: 'MTQ', name: 'Martinique' },
  { code: 'GUF', name: 'Guyane' },
  { code: 'REU', name: 'La Réunion' },
  { code: 'MAY', name: 'Mayotte' },
];

// Italy Regions (20 regions)
export const ITALY_REGIONS = [
  { code: 'ABR', name: 'Abruzzes' },
  { code: 'BAS', name: 'Basilicate' },
  { code: 'CAL', name: 'Calabre' },
  { code: 'CAM', name: 'Campanie' },
  { code: 'EMR', name: 'Émilie-Romagne' },
  { code: 'FVG', name: 'Frioul-Vénétie Julienne' },
  { code: 'LAZ', name: 'Latium' },
  { code: 'LIG', name: 'Ligurie' },
  { code: 'LOM', name: 'Lombardie' },
  { code: 'MAR', name: 'Marches' },
  { code: 'MOL', name: 'Molise' },
  { code: 'PIE', name: 'Piémont' },
  { code: 'PUG', name: 'Pouilles' },
  { code: 'SAR', name: 'Sardaigne' },
  { code: 'SIC', name: 'Sicile' },
  { code: 'TOS', name: 'Toscane' },
  { code: 'TAA', name: 'Trentin-Haut-Adige' },
  { code: 'UMB', name: 'Ombrie' },
  { code: 'VDA', name: 'Vallée d\'Aoste' },
  { code: 'VEN', name: 'Vénétie' },
];

// Romania Regions (8 regions)
export const ROMANIA_REGIONS = [
  { code: 'NE', name: 'Nord-Est (Moldavie)' },
  { code: 'SE', name: 'Sud-Est (Dobroudja)' },
  { code: 'S', name: 'Sud (Muntenia)' },
  { code: 'SW', name: 'Sud-Ouest (Oltenia)' },
  { code: 'W', name: 'Ouest (Vest)' },
  { code: 'NW', name: 'Nord-Ouest (Nord-Vest)' },
  { code: 'C', name: 'Centre (Centru)' },
  { code: 'BI', name: 'Bucarest-Ilfov' },
];

// England Regions (9 regions)
export const ENGLAND_REGIONS = [
  { code: 'NE', name: 'North East' },
  { code: 'NW', name: 'North West' },
  { code: 'YH', name: 'Yorkshire and the Humber' },
  { code: 'EM', name: 'East Midlands' },
  { code: 'WM', name: 'West Midlands' },
  { code: 'EE', name: 'East of England' },
  { code: 'LDN', name: 'London' },
  { code: 'SE', name: 'South East' },
  { code: 'SW', name: 'South West' },
];

// Ukraine Oblasts (24 oblasts)
export const UKRAINE_REGIONS = [
  { code: 'VIN', name: 'Vinnytsia (Вінницька)' },
  { code: 'VOL', name: 'Volyn (Волинська)' },
  { code: 'DNI', name: 'Dnipropetrovsk (Дніпропетровська)' },
  { code: 'DON', name: 'Donetsk (Донецька)' },
  { code: 'ZHY', name: 'Zhytomyr (Житомирська)' },
  { code: 'ZAK', name: 'Zakarpattia (Закарпатська)' },
  { code: 'ZAP', name: 'Zaporizhzhia (Запорізька)' },
  { code: 'IVF', name: 'Ivano-Frankivsk (Івано-Франківська)' },
  { code: 'KYI', name: 'Kyiv (Київська)' },
  { code: 'KIR', name: 'Kirovohrad (Кіровоградська)' },
  { code: 'LUH', name: 'Luhansk (Луганська)' },
  { code: 'LVI', name: 'Lviv (Львівська)' },
  { code: 'MYK', name: 'Mykolaiv (Миколаївська)' },
  { code: 'ODE', name: 'Odesa (Одеська)' },
  { code: 'POL', name: 'Poltava (Полтавська)' },
  { code: 'RIV', name: 'Rivne (Рівненська)' },
  { code: 'SUM', name: 'Sumy (Сумська)' },
  { code: 'TER', name: 'Ternopil (Тернопільська)' },
  { code: 'KHA', name: 'Kharkiv (Харківська)' },
  { code: 'KHE', name: 'Kherson (Херсонська)' },
  { code: 'KHM', name: 'Khmelnytskyi (Хмельницька)' },
  { code: 'CHE', name: 'Cherkasy (Черкаська)' },
  { code: 'CHN', name: 'Chernivtsi (Чернівецька)' },
  { code: 'CHH', name: 'Chernihiv (Чернігівська)' },
];

// Russia Oblasts (42 oblasts)
export const RUSSIA_REGIONS = [
  { code: 'AMU', name: 'Amour (Амурская)' },
  { code: 'ARK', name: 'Arkhangelsk (Архангельская)' },
  { code: 'AST', name: 'Astrakhan (Астраханская)' },
  { code: 'BEL', name: 'Belgorod (Белгородская)' },
  { code: 'BRY', name: 'Briansk (Брянская)' },
  { code: 'VLA', name: 'Vladimir (Владимирская)' },
  { code: 'VGG', name: 'Volgograd (Волгоградская)' },
  { code: 'VLG', name: 'Vologda (Вологодская)' },
  { code: 'VOR', name: 'Voronej (Воронежская)' },
  { code: 'IRK', name: 'Irkoutsk (Иркутская)' },
  { code: 'YAR', name: 'Iaroslavl (Ярославская)' },
  { code: 'KGD', name: 'Kaliningrad (Калининградская)' },
  { code: 'KLU', name: 'Kalouga (Калужская)' },
  { code: 'KEM', name: 'Kemerovo (Кемеровская)' },
  { code: 'KIR', name: 'Kirov (Кировская)' },
  { code: 'KOS', name: 'Kostroma (Костромская)' },
  { code: 'KRS', name: 'Koursk (Курская)' },
  { code: 'LEN', name: 'Leningrad (Ленинградская)' },
  { code: 'LIP', name: 'Lipetsk (Липецкая)' },
  { code: 'MAG', name: 'Magadan (Магаданская)' },
  { code: 'MOS', name: 'Moscou (Московская)' },
  { code: 'MUR', name: 'Murmansk (Мурманская)' },
  { code: 'NIZ', name: 'Nijni Novgorod (Нижегородская)' },
  { code: 'NGR', name: 'Novgorod (Новгородская)' },
  { code: 'NVS', name: 'Novossibirsk (Новосибирская)' },
  { code: 'OMS', name: 'Omsk (Омская)' },
  { code: 'ORL', name: 'Orel (Орловская)' },
  { code: 'ORE', name: 'Orenbourg (Оренбургская)' },
  { code: 'ULY', name: 'Oulianovsk (Ульяновская)' },
  { code: 'PNZ', name: 'Penza (Пензенская)' },
  { code: 'PSK', name: 'Pskov (Псковская)' },
  { code: 'ROS', name: 'Rostov (Ростовская)' },
  { code: 'RYA', name: 'Ryazan (Рязанская)' },
  { code: 'SAM', name: 'Samara (Самарская)' },
  { code: 'SAR', name: 'Saratov (Саратовская)' },
  { code: 'SVE', name: 'Sverdlovsk (Свердловская)' },
  { code: 'SMO', name: 'Smolensk (Смоленская)' },
  { code: 'TAM', name: 'Tambov (Тамбовская)' },
  { code: 'CHE', name: 'Tcheliabinsk (Челябинская)' },
  { code: 'TVE', name: 'Tver (Тверская)' },
  { code: 'TOM', name: 'Tomsk (Томская)' },
  { code: 'TUL', name: 'Toula (Тульская)' },
  { code: 'TYU', name: 'Tiumen (Тюменская)' },
];

// Israel Districts
export const ISRAEL_REGIONS = [
  { code: 'JER', name: 'District de Jérusalem' },
  { code: 'NOR', name: 'District du Nord' },
  { code: 'HAI', name: 'District de Haïfa' },
  { code: 'CEN', name: 'District Central' },
  { code: 'TAV', name: 'District de Tel Aviv' },
  { code: 'SUD', name: 'District du Sud' },
  { code: 'JUS', name: 'Judée et Samarie' },
];

// France Departments (existing)
export const FRANCE_DEPARTMENTS = {
  'ARA': [
    { code: '01', name: 'Ain' },
    { code: '03', name: 'Allier' },
    { code: '07', name: 'Ardèche' },
    { code: '15', name: 'Cantal' },
    { code: '26', name: 'Drôme' },
    { code: '38', name: 'Isère' },
    { code: '42', name: 'Loire' },
    { code: '43', name: 'Haute-Loire' },
    { code: '63', name: 'Puy-de-Dôme' },
    { code: '69', name: 'Rhône' },
    { code: '73', name: 'Savoie' },
    { code: '74', name: 'Haute-Savoie' },
  ],
  'BFC': [
    { code: '21', name: 'Côte-d\'Or' },
    { code: '25', name: 'Doubs' },
    { code: '39', name: 'Jura' },
    { code: '58', name: 'Nièvre' },
    { code: '70', name: 'Haute-Saône' },
    { code: '71', name: 'Saône-et-Loire' },
    { code: '89', name: 'Yonne' },
    { code: '90', name: 'Territoire de Belfort' },
  ],
  'BRE': [
    { code: '22', name: 'Côtes-d\'Armor' },
    { code: '29', name: 'Finistère' },
    { code: '35', name: 'Ille-et-Vilaine' },
    { code: '56', name: 'Morbihan' },
  ],
  'CVL': [
    { code: '18', name: 'Cher' },
    { code: '28', name: 'Eure-et-Loir' },
    { code: '36', name: 'Indre' },
    { code: '37', name: 'Indre-et-Loire' },
    { code: '41', name: 'Loir-et-Cher' },
    { code: '45', name: 'Loiret' },
  ],
  'COR': [
    { code: '2A', name: 'Corse-du-Sud' },
    { code: '2B', name: 'Haute-Corse' },
  ],
  'GES': [
    { code: '08', name: 'Ardennes' },
    { code: '10', name: 'Aube' },
    { code: '51', name: 'Marne' },
    { code: '52', name: 'Haute-Marne' },
    { code: '54', name: 'Meurthe-et-Moselle' },
    { code: '55', name: 'Meuse' },
    { code: '57', name: 'Moselle' },
    { code: '67', name: 'Bas-Rhin' },
    { code: '68', name: 'Haut-Rhin' },
    { code: '88', name: 'Vosges' },
  ],
  'HDF': [
    { code: '02', name: 'Aisne' },
    { code: '59', name: 'Nord' },
    { code: '60', name: 'Oise' },
    { code: '62', name: 'Pas-de-Calais' },
    { code: '80', name: 'Somme' },
  ],
  'IDF': [
    { code: '75', name: 'Paris' },
    { code: '77', name: 'Seine-et-Marne' },
    { code: '78', name: 'Yvelines' },
    { code: '91', name: 'Essonne' },
    { code: '92', name: 'Hauts-de-Seine' },
    { code: '93', name: 'Seine-Saint-Denis' },
    { code: '94', name: 'Val-de-Marne' },
    { code: '95', name: 'Val-d\'Oise' },
  ],
  'NOR': [
    { code: '14', name: 'Calvados' },
    { code: '27', name: 'Eure' },
    { code: '50', name: 'Manche' },
    { code: '61', name: 'Orne' },
    { code: '76', name: 'Seine-Maritime' },
  ],
  'NAQ': [
    { code: '16', name: 'Charente' },
    { code: '17', name: 'Charente-Maritime' },
    { code: '19', name: 'Corrèze' },
    { code: '23', name: 'Creuse' },
    { code: '24', name: 'Dordogne' },
    { code: '33', name: 'Gironde' },
    { code: '40', name: 'Landes' },
    { code: '47', name: 'Lot-et-Garonne' },
    { code: '64', name: 'Pyrénées-Atlantiques' },
    { code: '79', name: 'Deux-Sèvres' },
    { code: '86', name: 'Vienne' },
    { code: '87', name: 'Haute-Vienne' },
  ],
  'OCC': [
    { code: '09', name: 'Ariège' },
    { code: '11', name: 'Aude' },
    { code: '12', name: 'Aveyron' },
    { code: '30', name: 'Gard' },
    { code: '31', name: 'Haute-Garonne' },
    { code: '32', name: 'Gers' },
    { code: '34', name: 'Hérault' },
    { code: '46', name: 'Lot' },
    { code: '48', name: 'Lozère' },
    { code: '65', name: 'Hautes-Pyrénées' },
    { code: '66', name: 'Pyrénées-Orientales' },
    { code: '81', name: 'Tarn' },
    { code: '82', name: 'Tarn-et-Garonne' },
  ],
  'PDL': [
    { code: '44', name: 'Loire-Atlantique' },
    { code: '49', name: 'Maine-et-Loire' },
    { code: '53', name: 'Mayenne' },
    { code: '72', name: 'Sarthe' },
    { code: '85', name: 'Vendée' },
  ],
  'PAC': [
    { code: '04', name: 'Alpes-de-Haute-Provence' },
    { code: '05', name: 'Hautes-Alpes' },
    { code: '06', name: 'Alpes-Maritimes' },
    { code: '13', name: 'Bouches-du-Rhône' },
    { code: '83', name: 'Var' },
    { code: '84', name: 'Vaucluse' },
  ],
  'GUA': [{ code: '971', name: 'Guadeloupe' }],
  'MTQ': [{ code: '972', name: 'Martinique' }],
  'GUF': [{ code: '973', name: 'Guyane' }],
  'REU': [{ code: '974', name: 'La Réunion' }],
  'MAY': [{ code: '976', name: 'Mayotte' }],
};

// Get regions by country
export const getRegionsByCountry = (countryCode) => {
  switch (countryCode) {
    case 'FR':
      return FRANCE_REGIONS;
    case 'IT':
      return ITALY_REGIONS;
    case 'RO':
      return ROMANIA_REGIONS;
    case 'GB':
      return ENGLAND_REGIONS;
    case 'UA':
      return UKRAINE_REGIONS;
    case 'RU':
      return RUSSIA_REGIONS;
    case 'IL':
      return ISRAEL_REGIONS;
    default:
      return [];
  }
};

// Helper functions
export const getCountryName = (code) => {
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country.name : code;
};

export const getRegionName = (code, countryCode = 'FR') => {
  const regions = getRegionsByCountry(countryCode);
  const region = regions.find(r => r.code === code);
  return region ? region.name : code;
};

export const getDepartmentName = (regionCode, deptCode) => {
  const departments = FRANCE_DEPARTMENTS[regionCode] || [];
  const dept = departments.find(d => d.code === deptCode);
  return dept ? dept.name : deptCode;
};

export const getDepartmentsByRegion = (regionCode) => {
  return FRANCE_DEPARTMENTS[regionCode] || [];
};
